import React from 'react';
import MaterialTableFooter from '@mui/material/TableFooter';
import type {TableFooterProps as MaterialTableFooterProps} from '@mui/material/TableFooter';

export type TableFooterProps = MaterialTableFooterProps;

export const TableFooter = React.forwardRef<any, TableFooterProps>(({
    children, ...props
},
ref) => (
    <MaterialTableFooter
        ref={ref}
        {...props}
    >
        {children}
    </MaterialTableFooter>
));

TableFooter.displayName = 'TableFooter';
